// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/messaging';
import { ɵzoneWrap } from '@angular/fire';
import {
  deleteToken as _deleteToken,
  getMessaging as _getMessaging,
  getToken as _getToken,
  isSupported as _isSupported,
  onMessage as _onMessage
} from 'firebase/messaging';

export const deleteToken = ɵzoneWrap(_deleteToken, true, 2);
export const getMessaging = ɵzoneWrap(_getMessaging, true);
export const getToken = ɵzoneWrap(_getToken, true);
export const isSupported = ɵzoneWrap(_isSupported, false);
export const onMessage = ɵzoneWrap(_onMessage, false);
